exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-switch.is-disabled[data-v-27c01402]{opacity:1}[data-v-27c01402] .el-switch__label{cursor:pointer !important}.znx-text[data-v-27c01402]{overflow:hidden;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical}", ""]);

// exports
